import {
  GET_COMPANIES,
  GET_COMPANIES_FAIL,
  GET_COMPANIES_SUCCESS,
  ADD_NEW_COMPANY,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAIL,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAIL,
  DELETE_COMPANIES,
  DELETE_COMPANIES_SUCCESS,
  DELETE_COMPANIES_FAIL,
  GET_COMPANY_DETAIL,
  GET_COMPANY_DETAIL_FAIL,
  GET_COMPANY_DETAIL_SUCCESS,
  SET_COMPANIES_SEARCH_QUERY,
  RESET_COMPANIES_SEARCH_QUERY,
} from "./actionTypes"

// reset Company Search Query
export const resetCompanySearchQuery = () => ({
  type: RESET_COMPANIES_SEARCH_QUERY,
})

// set Company Search Query
export const setCompanySearchQuery = searchQuery => ({
  type: SET_COMPANIES_SEARCH_QUERY,
  payload: searchQuery,
})

// COMPANIES
export const getCompanyDetail = id => ({
  type: GET_COMPANY_DETAIL,
  id,
})

export const getCompanyDetailSuccess = company => ({
  type: GET_COMPANY_DETAIL_SUCCESS,
  payload: company,
})

export const getCompanyDetailFail = error => ({
  type: GET_COMPANY_DETAIL_FAIL,
  payload: error,
})

// get
export const getCompanies = payload => ({
  type: GET_COMPANIES,
  payload: payload || {},
})

export const getCompaniesSuccess = companies => ({
  type: GET_COMPANIES_SUCCESS,
  payload: companies,
})

export const getCompaniesFail = error => ({
  type: GET_COMPANIES_FAIL,
  payload: error,
})

// Add
export const addNewCompany = company => ({
  type: ADD_NEW_COMPANY,
  payload: company,
})

export const addCompanySuccess = company => ({
  type: ADD_COMPANY_SUCCESS,
  payload: company,
})

export const addCompanyFail = error => ({
  type: ADD_COMPANY_FAIL,
  payload: error,
})

// update
export const updateCompany = company => ({
  type: UPDATE_COMPANY,
  payload: company,
})

export const updateCompanySuccess = company => ({
  type: UPDATE_COMPANY_SUCCESS,
  payload: company,
})

export const updateCompanyFail = error => ({
  type: UPDATE_COMPANY_FAIL,
  payload: error,
})

//delete
export const deleteCompanies = companies => ({
  type: DELETE_COMPANIES,
  payload: companies,
})

export const deleteCompaniesSuccess = companies => ({
  type: DELETE_COMPANIES_SUCCESS,
  payload: companies,
})

export const deleteCompaniesFail = error => ({
  type: DELETE_COMPANIES_FAIL,
  payload: error,
})
